import { APP_HOST_API_KEY, HOST_API_TOKEN } from '../config-global';

import { ApolloClient, InMemoryCache, from } from '@apollo/client';
import { onError } from '@apollo/client/link/error';

const errorLink = onError(({ graphqlErrors, networkErros }) => {
  if (graphqlErrors) {
    alert('GraphQlErrors....');
  }
});

const apolloClient = new ApolloClient({
  uri: APP_HOST_API_KEY + '/graphql',
  cache: new InMemoryCache(),
});

export default apolloClient;
